import Vue from 'vue'
import Router from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(Router)

import general from './routes/_general'
import auth from './routes/_auth'
import client from './routes/_client'
import manager from './routes/_manager'
// import NotFound from '@/components/NotFound404.vue'

const routes = [
  general,
  auth,
  client,
  manager,
  // {
  //   path: '/notfound404',
  //   name: 'NotFound',
  //   component: NotFound
  // },
  // {
  //   path: '*',
  //   redirect: '/notfound404'
  // }
]

const router = new Router({
  mode: 'history',
  base: '/cabinet/',
  routes
})

export default router
